<!-- Left side column. contains the logo and sidebar -->
<aside class="main-sidebar">
    <section class="sidebar">
        <div class="user-panel">
            <div class="pull-left image">
                <img src="./assets/images/user.png" class="img-circle" alt="User Image">
            </div>
            <div class="pull-left info">
                <p>Participante</p>
                <a href="javascript:void(0)"><i class="fa fa-circle text-success"></i> Status: Online</a>
            </div>
        </div>

        <form action="#" method="get" [formGroup]='modeloAso' (submit)='0;' class="sidebar-form">
            <div class="e-input-group">
                <input class="e-input" type="text" formControlName='nome' style="width: 100%"
                    placeholder="Procurar eleições..." />

                <span class="e-input-group-icon fa fa-search" (click)='0;'></span>
            </div>
        </form>

        <ul class="sidebar-menu" data-widget="tree">
            <li class="header">SMOCipa</li>

            <li [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
                <a [routerLink]="'/'">
                    <i class="fa fa-home"></i>
                    <span>Início</span>
                </a>
            </li>

            <li [routerLinkActive]="'active'">
                <a [routerLink]="'/eleicoes'">
                    <i class="fa fa-users"></i>
                    <span>Eleições da CIPA</span>
                </a>
            </li>

            <li [routerLinkActive]="'active'">
                <a [routerLink]="'/conta'">
                    <i class="fa fa-user-cog"></i>
                    <span>Minha Conta</span>
                </a>
            </li>

            <li class="treeview disabled" [routerLinkActive]="'active menu-open'">
                <a href="#">
                    <i class="fa fa-cog"></i>
                    <span>Configurações</span>
                    <span class="pull-right-container">
                        <i class="fa fa-angle-left pull-right"></i>
                    </span>
                </a>
                <ul class="treeview-menu">
                    <li [routerLinkActive]="'active'">
                        <a [routerLink]="'/configuracoes/notificacoes'">Notificações</a>
                    </li>
                    <li [routerLinkActive]="'active'">
                        <a [routerLink]="'/configuracoes/privacidade'">Privacidade</a>
                    </li>
                </ul>
            </li>

            <li class="disabled">
                <a href="#" (click)="$event.preventDefault()" id="feedback-button">
                    <i class="fa fa-bullhorn"></i>
                    <span>Reportar Problema</span>
                </a>
            </li>
        </ul>
    </section>
</aside>
